import { DefaultPallet, HSLColor } from "./types";
import chroma from "chroma-js";

function findClosestColor(palette, color) {
  let minDistance = Number.MAX_SAFE_INTEGER;
  let closestColor = [];
  Object.entries(DefaultPallet).forEach(([colorKey, value]) => {
    const distance = distanceBetweenColors(
      cssColorToHsl(value),
      cssColorToHsl(color),
    );
    if (distance < minDistance) {
      minDistance = distance;
      closestColor = [colorKey, value];
    }
  });
  return closestColor;
}

function applyDistance(paletteA, paletteB, schemeColor) {
  const HslPaletteA = cssColorToHsl(paletteA);
  const HslPaletteB = cssColorToHsl(paletteB);

  const BtoADistance = HslPaletteB.h - HslPaletteA.h;

  const hslSchemeColor = cssColorToHsl(schemeColor);
  return hslColorToHexColor({
    ...hslSchemeColor,
    h: (hslSchemeColor.h + BtoADistance) % 360,
  });
}

export function interpolateColorsUsingHSL(palette, scheme) {
  const newScheme = {};
  Object.entries(scheme).forEach(([colorKey, colorValue]) => {
    const [closestPalletColorName] = findClosestColor(
      DefaultPallet,
      colorValue,
    );

    const interpolatedColor = applyDistance(
      DefaultPallet[closestPalletColorName],
      palette[closestPalletColorName],
      colorValue,
    );
    newScheme[colorKey] = interpolatedColor;
  });

  return newScheme;
}

function hslColorToHexColor({ h, s, l }) {
  return chroma.hsl(h, s, l).hex();
}

function cssColorToHsl(hex) {
  const [h, s, l] = chroma(hex).hsl();
  return { h: h || 0, s: s || 0, l: l || 0 } as HSLColor;
}

export function distanceBetweenColors(hsl1: HSLColor, hsl2: HSLColor) {
  const absDistance = Math.abs(hsl1.h - hsl2.h);
  return absDistance > 180 ? 360 - absDistance : absDistance;
}
